import dayjs from 'dayjs';

export const extractDate = (text: string) => {
  const dateRegex = /(\d{2})\.(\d{2})\.(\d{2})/;
  const match = text.match(dateRegex);

  if (!match) return;

  const [, year, month, day] = match;

  return dayjs(`20${year}-${month}-${day}`).format('YYYY-MM-DD');
};
